import { Component, inject } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { AppService } from '@services/app.services';
import { LinkService } from '@services/link.service';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-pro-legal-representative-error-modal',
    templateUrl: './pro-legal-representative-error-modal.component.html',
    styleUrl: 'pro-legal-representative-error-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class ProLegalRepresentativeErrorModalComponent extends ModalComponent {
    title: string = 'Attention !';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_legal_representative_pro',
        categorieClic: 'Modale_error',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Trouver_une_boutique',
        categorieClic: 'Modale_error',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_error',
    };

    public modalRef: ModalService;

    private appService = inject(AppService);

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    private onCloseHandler(): void {
        const errorUrl: string = LinkService.getStoreApointmentLink('panier-etape-siren-modale-erreur');
        this.appService.navigateTo(errorUrl);
    }
}
